<mat-card appearance="outlined" id="clever-login-card">
  <mat-card-content>
    <div id="clever-login-container">
      <img id="clever-logo" [src]="cleverLogo" alt="Clever Logo"/>
      @if ((bannerStatus$ | async)) {
        <mat-toolbar
          id="clever-login-banner"
          color="{{ bannerColor$ | async }}"
          fxFlexFill
          >
          <span id="clever-login-banner-message">
            {{ bannerMessage$ | async }}
          </span>
        </mat-toolbar>
      }
      @if (showProgressSpinner) {
        <mat-progress-spinner
          fxLayoutAlign="center"
          mode="indeterminate"
          >
        </mat-progress-spinner>
      }
    </div>
    <mat-card-actions id="car">
      @if (!showProgressSpinner) {
        <button
          id="cancel-link"
          mat-raised-button
          fxFill
          color="primary"
          (click)="cancel()"
          >
          Back to Login
        </button>
      }
    </mat-card-actions>
  </mat-card-content>
</mat-card>
